<template>
  <div>
    <el-dialog title="验证固件"  :close-on-click-modal="false" :append-to-body="true" :visible.sync="verifyDialogFlag" width="30%" v-if="rows.verifyStatus === 1 && rows.agains!=='agains' " :before-close="cancle">
      <div>
        <i class="el-icon-success"></i>
        固件升级完成
      </div>
       <el-progress :percentage="100" status="success" class="progress-bar"></el-progress>
       <div class="info">验证固件已完成，您可以开始进行<span style="color:red">批量升级</span>或<span style="color:red">重新验证</span>。</div>
       <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancle">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="验证固件"  :close-on-click-modal="false" :append-to-body="true" :visible.sync="verifyDialogFlag" width="30%" :before-close="cancle" v-else>
      <el-form :model="form" ref="ruleForm" :rules="rules">
        <el-form-item label="待升级版本号" prop="versionOptionsVal">
          <el-select
          v-model="form.versionOptionsVal"
          @change="versionChange"
          placeholder="请选择待升级版本号"
          style="width:100%"
          multiple
          :disabled="rows.firmwareType=== 1 ? true: false">
            <el-option
            v-for="item in versionOptions"
            :key="item.id"
            :label="item.moduleVersion"
            :value="item.moduleVersion"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="待验证设备" prop="waitVertifyDevice">
          <el-select
            :multiple="true"
            v-model="form.waitVertifyDevice"
            style="width:100%"
            ref="deviceScope"
            @focus="focusStatus&&openDrawer()"
            placeholder="请选择设备范围">
            <el-option
              v-for="item in waitVertifyDeviceOptions"
              :key="item.id"
              :label="item.deviceName"
              :value="item.deviceName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="升级超时时间(分)" prop="timeOutPeriod">
          <el-input v-model.number="form.timeOutPeriod"  placeholder="配置时间范围为 1~1440 分钟（ 24 小时），不填默认不会超时"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancle">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
    <Drawer
    ref="drawer"
    v-if="drawerFlag"
    :vValue="vValue"
    :ids="ids"
    :drawerFlag="drawerFlag"
    :popData="rows"
    :popDate="date"
    :versionOptions="versionOptions"
    @getChildData="getChildData"
    @closeDrawer="closeDrawer" ></Drawer>
  </div>
</template>
<script>
import { getVersions, add } from '@/api/productControl.js'
import Drawer from '@/components/VerifyFirmwareDialog/drawer.vue'
export default {
  props: {
    verifyDialogFlag: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Object
    },
    date: {
      type: Number
    }
  },
  components: {
    Drawer
  },
  data () {
    const fileNumber = (rule, value, callback) => {
      if (this.rows.firmwareType === 0 && this.form.versionOptionsVal.length === 0) {
        callback(new Error('请选择待升级版本号'))
      } else {
        callback()
      }
    }
    const checkUptime = (rule, value, callback) => {
      if (this.form.timeOutPeriod > 1440 || this.form.timeOutPeriod < 0 || isNaN(this.form.timeOutPeriod)) {
        return callback(new Error('请输入1-1440之间的整数'))
      } else {
        callback()
      }
    }
    return {
      // dialogFormVisible: false, // 组件开关
      versionOptions: [], // 版本号选项
      waitVertifyDeviceOptions: [], // 待升级版本号选项
      form: {
        versionOptionsVal: [],
        waitVertifyDevice: [],
        timeOutPeriod: ''
      },
      rules: {
        versionOptionsVal: [
          { required: true, validator: fileNumber, trigger: 'change' }
        ],
        waitVertifyDevice: [
          { required: true, message: '请选择待升级设备', trigger: 'change' }
        ],
        timeOutPeriod: [
          { validator: checkUptime, trigger: 'blur' }
        ]
      },
      focusStatus: true,
      drawerFlag: false,
      vValue: [], // 版本号
      ids: [] // 回传数据
    }
  },
  created () {
    this.$set(this.form, 'versionOptionsVal', [])
    this.$set(this.form, 'waitVertify', [])
    /* Bus.$emit('toDrawer', this.rows)
    Bus.test = 7777 */
  },
  watch: {
    focusStatus () {
      if (this.focusStatus === true) {
        this.$refs.deviceScope.blur()
      }
    },
    'form.versionOptionsVal': {
      deep: true,
      handler (val, old) {
        this.vValue = Object.assign([], val)
        if (val.length < old.length) {
          const differ = this.getArrDifference(val, old)// differ[0]则是那个不同的值
          console.log('daviceList', this.form.waitVertifyDevice)
          // TODO: 需将val跟old中的差值取出来进行删除
          this.waitVertifyDeviceOptions = this.waitVertifyDeviceOptions.filter((ele, index) => {
            console.log(ele, differ)
            return ele.deviceVersion !== differ[0]
          })
          console.log('deviceOptions', this.waitVertifyDeviceOptions)
          const deviceNameLists = []
          this.waitVertifyDeviceOptions.forEach(element => {
            deviceNameLists.push(element.deviceName)
          })
          this.form.waitVertifyDevice = deviceNameLists
        }
      }
    }
  },
  mounted () {
    if (this.rows.verifyStatus === 0 || (this.rows.verifyStatus === 1 && this.rows.agains === 'agains')) {
      const params = {
        params: {
          productKey: this.rows.productKey,
          moduleName: this.rows.module
        }
      }
      getVersions(params).then(res => {
        this.form.versionOptionsVal = []
        this.versionOptions = res.data.data
        if (this.rows.firmwareType === 1) {
          this.form.versionOptionsVal.push(this.rows.sourceVersion)
        }
      })
    }
  },
  methods: {
    getArrDifference (arr1, arr2) { // 去除相差的那个数
      return arr1.concat(arr2).filter(function (v, i, arr) {
        return arr.indexOf(v) === arr.lastIndexOf(v)
      })
    },
    getChildData (val) {
      const deviceNameList = []
      val.version.sort()
      val.deviceList.forEach(element => {
        deviceNameList.push(element.deviceName)
      })
      this.waitVertifyDeviceOptions = val.deviceList
      this.form.waitVertifyDevice = deviceNameList
      this.form.versionOptionsVal = [...new Set(val.version)]
    },
    cancle (val) {
      // this.dialogFormVisible = false
      this.$emit('closeVerifyDialog')
      if (val === 1) {
        this.$emit('reflash')
      }
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) { // 验证成功
          const params = {
            params: {
              strategyType: 0,
              batchType: this.rows.agains === 'agains' ? 2 : 0,
              upgradeScope: 1,
              upgradeTimeType: 0,
              firmwareId: this.rows.firmwareId,
              deviceList: this.waitVertifyDeviceOptions,
              sourceVersions: this.form.versionOptionsVal,
              upgradeTimeout: this.form.timeOutPeriod
            }
          }
          add(params).then(res => {
            if (res.data.code === 200) {
              this.$message({
                type: 'success',
                message: '验证完成'
              })
            } else {
              this.$message({
                type: 'error',
                mwssage: res.data.message
              })
            }
            // this.dialogFormVisible = false
            this.cancle(1)
          })
        }
      })
    },
    // 置空
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    openDrawer () {
      this.drawerFlag = true
      this.$refs.deviceScope.blur()
      this.focusStatus = false
      this.ids = this.waitVertifyDeviceOptions
    },
    // 关闭抽屉
    closeDrawer () {
      this.drawerFlag = false
      this.focusStatus = true
    },
    versionChange (val) {
      this.vValue = val
    }
  }
}
</script>

<style lang='less' scoped>
/deep/ .el-icon-success:before{
  color: green;
}
/deep/ .el-progress{
  margin-top: 8px;
  margin-bottom: 8px;
}
.info{
  color: #999;
  font-size: 12px;
}
/deep/ .el-tag__close{
    display: none
  }
</style>
